import { render, staticRenderFns } from "./salesmanAction.vue?vue&type=template&id=1b64d1c2&scoped=true"
import script from "./salesmanAction.vue?vue&type=script&lang=js"
export * from "./salesmanAction.vue?vue&type=script&lang=js"
import style0 from "./salesmanAction.vue?vue&type=style&index=0&id=1b64d1c2&prod&lang=css"
import style1 from "./salesmanAction.vue?vue&type=style&index=1&id=1b64d1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b64d1c2",
  null
  
)

export default component.exports